/**
 * ActivityTimeline Component
 * Timeline display of activity events
 */

import React from 'react';
import { I18n } from 'react-redux-i18n';
import { HealthEvents } from '../types';
import { EVENT_INFO } from '../constants';
import ActivityRow from './ActivityRow';
import styles from '../SystemHealth.module.css';

const I18N_PREFIX = 'systemSettings.systemHealth';

interface ActivityTimelineProps {
  events: HealthEvents;
}

export const ActivityTimeline: React.FC<ActivityTimelineProps> = ({
  events
}) => {
  // Filter out events that don't exist in the response
  const availableEvents = EVENT_INFO.filter(info => {
    return events[info.key] !== undefined;
  });

  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>{I18n.t(`${I18N_PREFIX}.sections.activityTimeline`)}</h3>
      <div className={styles.activityTimeline}>
        {availableEvents.map((info) => (
          <ActivityRow
            key={info.key}
            eventKey={info.key}
            label={I18n.t(info.label)}
            timestamp={events[info.key] ?? null}
          />
        ))}
      </div>
    </div>
  );
};

export default ActivityTimeline;
